import { configureIguazuREST } from 'iguazu-rest';
import { Map as ImmutableMap } from 'immutable';
/* istanbul ignore next */
function getOneAppConfig(state) {
  return ImmutableMap.isMap(state) ? state.get('config') : state.config;
}
/* istanbul ignore next */
const getp2pApiUrl = (state) => getOneAppConfig(state).get('p2pApiUrl');
/* istanbul ignore next */
const getTimeout = (state) => getOneAppConfig(state).get('TIMEOUT');
/* istanbul ignore next */
const configureIguazuResources = () => {
  configureIguazuREST({
    getToState: (state) => state.getIn(['modules', 'axp-peer-payments-partner-root', 'resources']),
    resources: {
      getProfile: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/accounts/profile`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
      postAuthCode: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/accounts/partners/venmo/token`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
      getMetaData: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/accounts/metadata`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
      postAccounts: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/accounts`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
      postCompletions: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/accounts/completions`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
      sendOtp: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/otp/send`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
      verifyOtp: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/otp/validate`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
      postOtpVerify: {
        fetch: (id, action, state) => ({
          url: `${getp2pApiUrl(state)}/otp/verify`,
          opts: {
            timeout: getTimeout(state),
          },
        }),
      },
    },
  });
};

configureIguazuResources();
